import { useQuery } from "@tanstack/react-query";
import getBoletins from "Api/boletins/list";
import { BoletinsListRequest } from "Services/Boletins/boletins";

export function useBoletins(params: BoletinsListRequest) {
  const query = () => getBoletins(params);

  return useQuery(["boletinsList", ...Object.values(params)], query);
}
